'use strict';

export default {
	SELECT: 'Select...',
	ALL: 'Show all'
};